jQuery(document).ready(function($) {
    
    function animateLines() {
    	var currentWindowPositionBottom = $(document).scrollTop() + $(window).height();
		$('.section-animation__line').each(function() {
			// Animation start = top of element + distance from bottom of screen
			var animationStart = $(this).offset().top + 200;
				animationLength = 180;
				animationFinish = animationStart + animationLength;

			// If current position is between animation start and finish
			if(currentWindowPositionBottom >= animationStart && currentWindowPositionBottom < animationFinish) {
				$(this).removeClass('section-animation__line--finished');
				$(this).removeClass('section-animation__line--inactive');

				// Get % of animation completed
				var currentAnimationPosition = animationFinish - currentWindowPositionBottom - animationLength;

					// Make a positive number
					currentAnimationPosition = currentAnimationPosition * -1;

				$(this).css('max-height', currentAnimationPosition + 'px');
			} else if(currentWindowPositionBottom > animationFinish) {
				$(this).addClass('section-animation__line--finished');
				$(this).removeClass('section-animation__line--inactive');
			} else {
				$(this).removeClass('section-animation__line--finished');
				$(this).addClass('section-animation__line--inactive');
			}
		});
    }

    function scrollIcon() {
    	var currentWindowPosition = $(document).scrollTop();

    	$('.scroll-icon').each(function() {
    		var $section = $(this).parents('section');
    			sectionTop = $section.offset().top;

    		if(currentWindowPosition > sectionTop) {
    			$(this).addClass('scroll-icon--active');
    		} else {
    			$(this).removeClass('scroll-icon--active');
    		}
    	});    
    }

    function fadeIn() {
    	if($(window).width() >= 992) {
	    	var currentWindowPositionBottom = $(document).scrollTop() + $(window).height();

	    	$('.animate-fadein--inactive').each(function() {
	    		var elementTop = $(this).offset().top;

	    		if(currentWindowPositionBottom > elementTop) {
	    			$(this).removeClass('animate-fadein--inactive');
	    		}
	    	});
	    }
    }

    function intro() {
    	if($(window).width() >= 992) {
    		$('.intro__left').css('left', 0);
    		$('.intro__right').css('right', 0);
    	}
    }

    $(window).scroll(function() {
    	animateLines();
    	scrollIcon();
    	fadeIn();
    });

    $(window).load(function() {
    	animateLines();
    	scrollIcon();
    	fadeIn();
    	intro();
    });
 
});
